import React from 'react';
import PropTypes from 'prop-types';
import YesNoModal from './YesNoModal';
import TaggerModal from './TaggerModal';
import LocalizedStrings from './localization.js';
import LibraryResults from './LibraryResults';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class LibraryResultsContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fixedHeader: true,
            fixedFooter: true,
            stripedRows: false,
            showRowHover: true,
            selectable: true,
            multiSelectable: true,
            enableSelectAll: true,
            deselectOnClickaway: false,
            showCheckboxes: true,
            height: '400px',
            showModal: false,
            showTaggerModal: false,
            showShareableModal: false,
            shareable: false,
        };
    }

    handleToggle = (event, toggled) => {
        this.setState({
            [event.target.name]: toggled,
        });
    };

    handleChange = (event) => {
        this.setState({ height: event.target.value });
    };


    handleEditItem = (evt, fileId) => {
        this.props.showFileDetail(fileId);
    };

    handleLoadMore = () => {
        this.props.handleLoadMoreData();
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    handleCloseTaggerModal = () => {
        this.setState({ showTaggerModal: false });
    }

    askForTag = (elements) => {
        if (elements.length > 0) {
            let ids = elements.map((element) => {
                return element.fileId;
            });
            this.setState({ showTaggerModal: true, pendingTagsFilesId: ids });
        }
    }

    confirmMultipleDelete = (elements) => {
        if (elements.length > 0) {
            let ids = elements.map((element) => {
                return element.fileId;
            });
            this.setState({ showModal: true, pendingDeleteFilesId: ids });
        }
    }

    pickFiles = (elements) => {
        if (elements.length > 0) {
            if (this.props.onPickFiles) {
                this.props.onPickFiles(elements);
            }
        }
    }

    handleTagSelected = (tags) => {
        let ids = this.state.pendingTagsFilesId;
        this.props.tagMultipleFiles(ids, tags);
    }

    handleDeleteSelected = () => {
        let ids = this.state.pendingDeleteFilesId;
        this.props.deleteMultipleFiles(ids);
    }

    makeShareableMultipleFiles = (elements) => {
        if (elements.length > 0) {
            let ids = elements.map((element) => {
                return element.fileId;
            });
            this.setState({ showShareableModal: true, pendingShareableFiles: ids });
        }
    }

    handleCloseShareableModal = () => {
        this.setState({ showShareableModal: false });
    }

    handleShareableChange = (event) => {
        this.setState({ shareable: event.target.checked });
    }

    handleShareableModalDone = () => {
        let ids = this.state.pendingShareableFiles;
        this.props.flagSharebleMultipleFiles(ids, this.state.shareable);
        this.setState({ showShareableModal: false, pendingShareableFiles: undefined, shareable: false });
    }

    render() {
        return (
            <div>
                <LibraryResults
                    isGrid={this.props.isList ? false : true}
                    tableData={this.props.tableData}
                    usersData={this.props.usersData}
                    loadMore={this.handleLoadMore}
                    tagMultipleFiles={this.askForTag}
                    deleteSelected={this.confirmMultipleDelete}
                    makeShareableMultipleFiles={this.makeShareableMultipleFiles}
                    pickFiles={this.pickFiles}
                    partialData={this.props.partialData}
                    isPicker={this.props.isPicker}
                    handleEditItem={this.handleEditItem}
                    multipleChoice={this.props.multipleChoice}

                />
                <TaggerModal
                    open={this.state.showTaggerModal}
                    handleClose={this.handleCloseTaggerModal}
                    handleYes={this.handleTagSelected}

                />
                <YesNoModal
                    open={this.state.showModal}
                    handleClose={this.handleCloseModal}
                    handleYes={this.handleDeleteSelected}
                    title={LocalizedStrings.deleteFile}
                    message={LocalizedStrings.deleteMultipleFilesMessage}
                    positive={LocalizedStrings.yes}
                    negative={LocalizedStrings.no}
                />
                <Dialog
                    open={this.state.showShareableModal}
                    onClose={this.handleCloseShareableModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{LocalizedStrings.shareableTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {LocalizedStrings.shareableDescription}
                            <br />
                            <Checkbox checked={this.state.shareable} onChange={this.handleShareableChange} />
                            {`  ${LocalizedStrings.shareable}`}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseShareableModal} color="primary">
                            {LocalizedStrings.cancel}
                        </Button>
                        <Button onClick={this.handleShareableModalDone} color="primary" autoFocus>
                            {LocalizedStrings.confirm}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div >
        );
    }
};

LibraryResultsContainer.propTypes = {
    multipleChoice: PropTypes.bool,
    showFileDetail: PropTypes.func.isRequired,
    handleLoadMoreData: PropTypes.func.isRequired,
    tableData: PropTypes.array.isRequired,
    usersData: PropTypes.object.isRequired,
    partialData: PropTypes.any,

    tagMultipleFiles: PropTypes.func.isRequired,
    deleteMultipleFiles: PropTypes.func.isRequired,
    flagSharebleMultipleFiles: PropTypes.func.isRequired,
    isList: PropTypes.bool.isRequired,
    isPicker: PropTypes.bool.isRequired,
    onPickFiles: PropTypes.func,

};

export default LibraryResultsContainer;